Service = App.loadClass 'core::Angular/Service'

class exports.SppAnalysisService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getCompanies: () =>
        return @http.post 'backend/admin/spp-analysis/get-companies'

    fetchProgramsUsers: (program, company) =>
        return @http.post 'backend/admin/spp-analysis/fetch-programs-users',
            program: program
            company: company

    getProgramForUser: (user = null, rep = null, program = null, fsr = null) =>
        return @http.post 'backend/admin/spp-analysis/get-program-for-user',
            user: user
            rep: rep
            program: program
            fsr: fsr

    fetchDeveloperData: (pp_id) =>
        return @http.post 'backend/admin/spp-analysis/get-developer-data',
            pp_id: pp_id

